document.addEventListener('DOMContentLoaded', function () {
  const inputs = document.getElementsByClassName('js-google-autocomplete');

  if (inputs.length === 0) {
    return;
  }

  const loadGoogleMapsAPI = () => {
    return new Promise((resolve, reject) => {
      if (typeof google !== 'undefined' && google.maps && google.maps.places) {
        return resolve();
      }

      const script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAx37KXOgn9MRHQuHoVItl5SkMCTDXispA&libraries=places&language=nl&region=nl';
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  };

  const initAutocomplete = () => {
    const options = {
      componentRestrictions: { country: 'nl' },
    };

    Array.from(inputs).forEach(function (input) {
      new google.maps.places.Autocomplete(input, options);
    });
  };

  loadGoogleMapsAPI()
    .then(initAutocomplete)
    .catch(() => {
      console.warn('Google Maps API failed to load');
    });
});
